import { LanguageOption } from '../models/language';

export const languages: readonly LanguageOption[] = [
  { flag: 'fi fi-br', name: 'Português', value: 'pt' },
  { flag: 'fi fi-gb', name: 'English', value: 'en' },
  { flag: 'fi fi-es', name: 'Español', value: 'es' },
] as const;
